import Vue from 'vue'
import Router from 'vue-router'
import * as Config from '@/config'
import Layout from '@/components/Layout.vue'
import PageNotFound from '@/components/404.vue'
import Login from '@/views/login/Index.vue'
import ForgotPassword from '@/views/login/ForgotPassword.vue'
import ResetPassword from '@/views/login/ResetPassword.vue'
import Dashboard from '@/views/dashboard/Index.vue'
import KeyAdd from '@/views/key/KeyAdd.vue'
import UserList from '@/views/user/UserList.vue'
import UserAdd from '@/views/user/UserAdd.vue'
import UserImport from '@/views/user/UserImport.vue'
import UserEdit from '@/views/user/UserEdit.vue'
import UserPcodeAdd from '@/views/user/UserPcodeAdd.vue'
import UserPassageAdd from '@/views/user/UserPassageAdd.vue'
import UserGateAdd from '@/views/user/UserGateAdd.vue'
import UserChangePassword from '@/views/user/UserChangePassword.vue'
import GroupList from '@/views/group/GroupList.vue'
import GroupAdd from '@/views/group/GroupAdd.vue'
import GroupUserAdd from '@/views/group/GroupUserAdd.vue'
import GroupGateAdd from '@/views/group/GroupGateAdd.vue'
import GroupImport from '@/views/group/GroupImport.vue'
import GroupUserImport from '@/views/group/GroupUserImport.vue'
import GroupGateImport from '@/views/group/GroupGateImport.vue'
import GroupEdit from '@/views/group/GroupEdit.vue'
import LogList from '@/views/log/LogList.vue'
import GateList from '@/views/gate/GateList.vue'
import GateAdd from '@/views/gate/GateAdd.vue'
import GateGroupAdd from '@/views/gate/GateGroupAdd.vue'
import GateUserAdd from '@/views/gate/GateUserAdd.vue'
import GateEdit from '@/views/gate/GateEdit.vue'
import GateImport from '@/views/gate/GateImport.vue'
import PhoneList from '@/views/phone/PhoneList.vue'
import PhoneImport from '@/views/phone/PhoneImport.vue'
import PhoneEdit from '@/views/phone/PhoneEdit.vue'
import PcodeList from '@/views/pcode/PcodeList.vue'
import PcodeAdd from '@/views/pcode/PcodeAdd.vue'
import PcodeEdit from '@/views/pcode/PcodeEdit.vue'
import PcodeImport from '@/views/pcode/PcodeImport.vue'
import SettingList from '@/views/setting/SettingList.vue'
import configLogEdit from '@/views/setting/configLogEdit.vue'
import ExportIndex from '@/views/export/ExportIndex.vue'
import Store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '*', component: PageNotFound },
    {
      path: Config.LOGIN_PATH,
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (!Store.state.auth.isLoggedIn) {
          // まだログイン場合
          next()
        } else {
          next({
            // ログインした場合
            path: Config.DASHBOARD_PATH
          })
        }
      }
    },
    {
      path: Config.FORGOT_PASSWORD_PATH,
      name: 'forgotpassword',
      component: ForgotPassword,
      beforeEnter: (to, from, next) => {
        if (!Store.state.auth.isLoggedIn) {
          // まだログイン場合
          next()
        } else {
          next({
            // ログインした場合
            path: Config.DASHBOARD_PATH
          })
        }
      }
    },
    {
      path: Config.RESET_PASSWORD_PATH,
      name: 'resetpassword',
      component: ResetPassword,
      beforeEnter: (to, from, next) => {
        if (!Store.state.auth.isLoggedIn) {
          // まだログイン場合
          next()
        } else {
          next({
            // ログインした場合
            path: Config.DASHBOARD_PATH
          })
        }
      }
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Dashboard,
          beforeEnter: requireAuth
        },
        {
          path: Config.DASHBOARD_PATH,
          name: 'dashboard',
          component: Dashboard,
          beforeEnter: requireAuth
        },
        {
          path: Config.KEY_ADD_PATH,
          name: 'keyadd',
          component: KeyAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.USER_PATH,
          name: 'user',
          component: UserList,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.USER_ADD_PATH,
          name: 'useradd',
          component: UserAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.USER_IMPORT_PATH,
          name: 'userimport',
          component: UserImport,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.USER_EDIT_PATH,
          name: 'useredit',
          component: UserEdit,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.USER_PCODE_ADD_PATH,
          name: 'userpcodeadd',
          component: UserPcodeAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.USER_PASSAGE_ADD_PATH,
          name: 'userpassageadd',
          component: UserPassageAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.USER_GATE_ADD_PATH,
          name: 'usergateadd',
          component: UserGateAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.USER_CHANGE_PASSWORDPASS_PATH,
          name: 'userchangepassword',
          component: UserChangePassword,
          beforeEnter: requireAuth
        },
        {
          path: Config.GROUP_PATH,
          name: 'group',
          component: GroupList,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GROUP_ADD_PATH,
          name: 'groupadd',
          component: GroupAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GROUP_USER_ADD_PATH,
          name: 'groupuseradd',
          component: GroupUserAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GROUP_GATE_ADD_PATH,
          name: 'groupgateadd',
          component: GroupGateAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GROUP_IMPORT_PATH,
          name: 'groupimport',
          component: GroupImport,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GROUP_USER_IMPORT_PATH,
          name: 'groupuserimport',
          component: GroupUserImport,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GROUP_GATE_IMPORT_PATH,
          name: 'groupgateimport',
          component: GroupGateImport,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GROUP_EDIT_PATH,
          name: 'groupedit',
          component: GroupEdit,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.PCODE_PATH,
          name: 'pcode',
          component: PcodeList,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.PCODE_ADD_PATH,
          name: 'pcodeadd',
          component: PcodeAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.PCODE_EDIT_PATH,
          name: 'pcodeedit',
          component: PcodeEdit,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.PCODE_IMPORT_PATH,
          name: 'pcodeimport',
          component: PcodeImport,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.LOG_PATH,
          name: 'logs',
          component: LogList,
          beforeEnter: requireAuth
        },
        {
          path: Config.GATE_PATH,
          name: 'gates',
          component: GateList,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GATE_ADD_PATH,
          name: 'gateadd',
          component: GateAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GATE_GROUP_ADD_PATH,
          name: 'gategroupadd',
          component: GateGroupAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GATE_USER_ADD_PATH,
          name: 'gateuseradd',
          component: GateUserAdd,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GATE_EDIT_PATH,
          name: 'gateedit',
          component: GateEdit,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.GATE_IMPORT_PATH,
          name: 'gateimport',
          component: GateImport,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.PHONE_PATH,
          name: 'phones',
          component: PhoneList,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.PHONE_IMPORT_PATH,
          name: 'phoneimport',
          component: PhoneImport,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.PHONE_EDIT_PATH,
          name: 'phoneedit',
          component: PhoneEdit,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.CONFIG_LOG_EDIT_PATH,
          name: 'configLogEdit',
          component: configLogEdit,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.SETTING_PATH,
          name: 'setting',
          component: SettingList,
          beforeEnter: requireAuthRole
        },
        {
          path: Config.EXPORT_PATH,
          name: 'export',
          component: ExportIndex,
          beforeEnter: requireAuthRole
        }
      ]
    }
  ]
})

// もうログインするかどうかチェック関数
function requireAuth (to, from, next) {
  if (!Store.state.auth.isLoggedIn) {
    next({
      // まだログイン場合
      path: Config.LOGIN_PATH
    })
  } else {
    // ログインした場合
    next()
  }
}
function requireAuthRole (to, from, next) {
  if (!Store.state.auth.isLoggedIn) {
    next({
      // まだログイン場合
      path: Config.LOGIN_PATH
    })
  } else {
    if (localStorage.isAdmin === 'true') {
      next()
    } else {
      next({
        path: Config.DASHBOARD_PATH
      })
    }
  }
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js